/**
 * @desc 查询可用库存
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockWarehousePlatformSkuQry, options?: any) {
  return updateResponse(
    http(URL + `/stock/getStockWarehousePlatformUseQty`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
